module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 10-4a62a2a1117cdf657ad235200b17ff19.jpg";